import { render, staticRenderFns } from "./EventsTab.vue?vue&type=template&id=fc53f1de&"
import script from "./EventsTab.vue?vue&type=script&lang=js&"
export * from "./EventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports